// extracted by mini-css-extract-plugin
export var editor = "_12-0";
export var flowSidebar = "_40-2";